<template>
  <div class="breadcrumb-bg">
    <div class="breadcrumb-title">
      <i>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item v-for="(item,index) in titleArr" :key="index" v-if="titleArr">
            {{item.title}}
          </el-breadcrumb-item>
          <el-breadcrumb-item v-for="(item,index) in $route.matched" :key="index"
                              v-if="titleArr.length==0">{{item.meta.title}}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </i>
      <b>{{title ? title : $route.name}}</b>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
      }
    },
    data() {
      return {
        titleArr: [],
      }
    },
    watch: {
      title(val) {
        let arr = this.$route.matched;
        let newArr = arr.map((item, index, arr) => {
          if (item.meta.title == '表单') {
            newArr = {title: val};
          } else {
            newArr = {title: item.meta.title};
          }
          return newArr;
        });
        this.titleArr = newArr;
      }
    },
  };
</script>

<style scoped lang="less">

</style>
